import { Input } from '@chakra-ui/react'
import { mdiMagnify } from '@mdi/js'
import Icon from '@mdi/react'
import { ChangeEvent } from 'react'
import { useTranslation } from 'react-i18next'

import { InputGroup } from '@/components/ui/input-group'
import useColorModeValue from '@/hooks/useColorModeValue'

const Search = ({ searchValue, onSearch }: { searchValue: string; onSearch: (e: ChangeEvent<HTMLInputElement>) => void }) => {
    const { t } = useTranslation()

    return (
        <InputGroup
            flex="1"
            startElement={<Icon path={mdiMagnify} size="18px" color={useColorModeValue('var(--chakra-colors-dark-700)', 'white')} />}
            startElementProps={{ pointerEvents: 'none' }}
        >
            <Input variant="search" value={searchValue} placeholder={t('global.search.placeholder')} onChange={onSearch} />
        </InputGroup>
    )
}

export default Search
